import { SECONDARY_COLOR } from 'src/theme';

// Neutral surfaces / hairlines shared by the edit modal and the PDF panel.
export const BILL_BORDER = '#e5e7eb';
export const BILL_SURFACE_MUTED = '#fafafa';
export const BILL_PDF_BACKDROP = '#f0f2f5';

// Read-only value text (labels use SECONDARY_COLOR from the theme).
export const BILL_VALUE_COLOR = '#262626';

// Empty-value placeholder used everywhere a field can be missing.
export const EMPTY_VALUE = '—';

// Shared field typography for the edit-modal sections: an uppercase secondary label above a value/control.
export const billLabelStyle = { fontSize: 12, color: SECONDARY_COLOR, letterSpacing: '0.03em' } as const;
export const billValueStyle = { display: 'block', fontSize: 13, color: BILL_VALUE_COLOR, fontWeight: 500 } as const;
